import { useQuery } from '@tanstack/react-query';

import { useApplicationContext } from '~/shared/context/use-application-context';
import { announcementHistoryResponseSchema } from '~/shared/data-contract/announcements';

import { announcementKeys } from './query-keys';

export const useAnnouncementHistory = () => {
    const { validatingCobrainerApiFetcher } = useApplicationContext();

    return useQuery({
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(announcementHistoryResponseSchema, {
                pathname: '/announcements/history',
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: announcementKeys.history(),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 5 * 60 * 1000,
        throwOnError: false,
    });
};
